import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DrawingToolView from './DrawingToolApp';

var DrawingToolReadBox = /*#__PURE__*/function (_Component) {
  _inherits(DrawingToolReadBox, _Component);

  var _super = _createSuper(DrawingToolReadBox);

  function DrawingToolReadBox(props) {
    var _this;

    _classCallCheck(this, DrawingToolReadBox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "autoResize", function () {
      // return
      // console.log("kz drawingToolAutoResize 0 ")
      // console.log("kz drawingToolAutoResize ", document.getElementById('DrawingToolReadBox'))
      // let width = document.getElementById('DrawingToolReadBox').offsetWidth || 640
      // let height = document.getElementById('DrawingToolReadBox').offsetHeight || 480
      var width = _.get(document.getElementById('DrawingToolReadBox'), 'offsetWidth', 640);

      var height = _.get(document.getElementById('DrawingToolReadBox'), 'offsetHeight', 480);

      if (width > 1280) {
        height = height * (1280 / width);
        width = 1280;
      }

      _this.setState({
        width: width,
        height: height
      });

      _this.startResize();
    });

    _defineProperty(_assertThisInitialized(_this), "startResize", function () {
      var actualResizeHandler = function actualResizeHandler() {
        try {
          // let width = document.getElementById('DrawingToolReadBox').offsetWidth
          // let height = document.getElementById('DrawingToolReadBox').offsetHeight
          var width = _.get(document.getElementById('DrawingToolAppBox'), 'offsetWidth', 640);

          var height = _.get(document.getElementById('DrawingToolAppBox'), 'offsetHeight', 480);

          _this.setState({
            width: width,
            height: height
          });
        } catch (error) {
          console.warn('resize fail for DrawingToolReadBox', error);
        }
      }; // var resizeTimeout;


      function resizeThrottler() {
        var _this2 = this;

        // ignore resize events as long as an actualResizeHandler execution is in the queue
        if (!this.resizeReadBoxTimeout) {
          this.resizeReadBoxTimeout = setTimeout(function () {
            _this2.resizeReadBoxTimeout = null;
            actualResizeHandler(); // The actualResizeHandler will execute at a rate of 15fps
          }, 10);
        }
      }

      _this.resizeThrottler = resizeThrottler;
      window.addEventListener('resize', resizeThrottler, false);
      window.resizeThrottler = resizeThrottler;
    });

    _defineProperty(_assertThisInitialized(_this), "stopResize", function () {
      window.removeEventListener("resize", _this.resizeThrottler);
      clearTimeout(_this.resizeReadBoxTimeout);
      window.resizeThrottler = null;
    });

    _this.state = {
      width: 640,
      height: 480
    };
    return _this;
  }

  _createClass(DrawingToolReadBox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.selected && this.props.selected) {
        this.autoResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopResize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isShow = _this$props.isShow,
          url = _this$props.url,
          selected = _this$props.selected;
      return /*#__PURE__*/React.createElement("div", {
        id: "DrawingToolReadBox",
        className: "analysis-right"
      }, isShow ? /*#__PURE__*/React.createElement(DrawingToolView, {
        id: "conditionOverview",
        key: "read" + url + selected,
        url: url,
        width: this.state.width,
        height: this.state.height
      }) : null);
    }
  }]);

  return DrawingToolReadBox;
}(Component);

DrawingToolReadBox.propTypes = {
  isShow: PropTypes.bool,
  url: PropTypes.string,
  selected: PropTypes.string
};
export default DrawingToolReadBox;